<form [formGroup]="form" *ngIf="form">
  <div>
    <span class="small weight-medium">
      {{ "sharedFeatures.ZeroPrices" | translate }}
    </span>
  </div>
  <mat-radio-group formControlName="isZeroShipmentPrice">
    <mat-radio-button color="primary" [value]="true"></mat-radio-button>
    <mat-label class="text-700 small">{{ "sharedFeatures.UseZeroPrices" | translate }}</mat-label>
    <mat-radio-button color="primary" [value]="false"></mat-radio-button>
    <mat-label class="text-700 small">{{ "sharedFeatures.UseDefaultPrices" | translate }}</mat-label>
  </mat-radio-group>
</form>